import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";

export const ReportElementNoteEdit = {
  Edit: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const reportElementNoteEditData: any = state.data;
      const url = "./php/report/report-element-note-editor-proxy.php";
      await axios
        .post(url, reportElementNoteEditData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
